import React, { FC } from 'react';
import ReactModal from 'react-modal';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

export const ModalRestrictedContainer: FC<Props> = ({
  isOpen,
  onRequestClose,
  children,
}) => {
  const customProps = {
    data: { 'test-id': 'restricted-modal' },
    className: 'react-modal',
    overlayClassName: 'react-modal__overlay',
    isOpen,
    ariaHideApp: false,
    onRequestClose,
  };

  return <ReactModal {...customProps}>{children}</ReactModal>;
};
